import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = [ "searchform" ]

  connect() {
  }

  reset() {
    document.querySelectorAll('.search-field').forEach(e => {
      if (e.choices) {
        // Clear Choices.js selection
        e.choices.removeActiveItems()
        e.choices.setChoiceByValue('')
      } else {
        // Clear regular input fields
        e.value = ''
      }
    })
    this.searchformTarget.requestSubmit()
  }

  update() {
    this.searchformTarget.requestSubmit()
  }
}
